
import Vue from 'vue'
import Component from 'vue-class-component';
import EventBus from './../../eventBus'
import { Validations } from 'vuelidate-property-decorators';
import { required, email } from "vuelidate/lib/validators"

@Component
export default class Login extends Vue{
  // Data
  user = {
      email: '',
      password: ''
  }
  @Validations()
    validations = {
        user: {
            password: { 
                required,
            },
            email: { required, email },
        }
    }

  nextURL: string = ''
  error: any = {
      generalMessage: '',
      errors: []
  }
  activeScreen: string = 'main'
  showPassword: boolean = false;
  formError: string[] = []

  //computed
  get activeUser () {
    return this.$store.state.activeUser
  }

  get isButtonDisabled(): boolean {
        if (!this.user.email || !this.user.password) {
            return true
        } else {
            return false
        }
    }

  // checkErrors () {
  //       this.formError = []
  //       if (!this.user.email) {
  //           this.formError.push("Email is required")
  //       } 
  //   }

    // get validEmail (): boolean {
    //   var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   return re.test(this.user.email);
    // }

  // methods
  onSubmit() {
    this.activeScreen = 'loading'
    EventBus.$emit('activeScreen', this.activeScreen)
    this.$store.dispatch("authenticateUser", this.user).then((response: any) => {

        if( this.nextURL ){
          this.$router.replace({ path : this.nextURL })
        } else {
          if(this.activeUser.roles.indexOf("admin") > -1){
            this.$router.replace({path:'/sequences'})
          }else{
            this.$router.replace({path:'/sequences'})
          }
        }
      
    }).catch((err: any) => {
      this.error.generalMessage = err.message
      this.activeScreen = "main"
      EventBus.$emit('activeScreen', this.activeScreen)
    });
  }

  resetPassword() {
    /**TODO: consume endpoint to reset password */
    this.$router.push('/reset-password')
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

}
